import styled from '@emotion/styled';
import React, { useEffect, useState } from 'react'
import MuiAppBar from '@mui/material/AppBar';
import MuiDrawer from '@mui/material/Drawer';
import { useTheme } from '@mui/styles';
import { Avatar, Badge, Box, Divider, FormControlLabel, Grid, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, ListSubheader, Menu, MenuItem, Toolbar, Tooltip, Typography } from '@mui/material';
import { AccountBalanceWalletOutlined, Article, Assignment, AssignmentIndOutlined, ChevronLeft, ChevronRight, DoneAllOutlined, Home, Logout, MenuOutlined, NotificationsOutlined, Sync } from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';
import SwitchTheme from '../../../components/SwitchTheme';
import { base_url } from '../../../utils/GlobalVariables';
import { CustomDescrypt } from '../../../utils/MyEncryption';
import { NotifStore } from '../../../store/UserStore';

const drawerWidth = 280;

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);

const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: 4,
        top: 8,
        padding: '0 4px',
    },
}));

const NavVr = (props) => {
    const theme = useTheme();
    // const [open, setOpen] = useState(true);
    const location = useLocation();
    const [isOpenState, setIsOpenState] = useState(true);
    const [anchorElUser, setAnchorElUser] = useState(null);
    const [anchorElNotif, setAnchorElNotif] = useState(null);
    const [profilPict, setProfilPict] = useState();

    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));

    const pemberitahuans = NotifStore((state) => state.pemberitahuans);
    const resetPemberitahuans = NotifStore((state) => state.resetPemberitahuans);

    useEffect(() => {
        setProfilPict(base_url + '/uploads/images/verifikator/' + decryptedUser.username + '.png')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const toggleDrawer = (state) => {
        setIsOpenState(state);
    };

    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const handleOpenNotif = (event) => {
        setAnchorElNotif(event.currentTarget);
    };

    const handleCloseNotif = () => {
        setAnchorElNotif(null);
        resetPemberitahuans();
    };

    const DrawerHeader = styled('div')(({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    }));

    return (
        <>
            <Box sx={{ display: 'flex' }} mb={2}>
                {/* <CssBaseline /> */}
                <AppBar position="fixed" open={isOpenState}>
                    <Toolbar sx={{ background: theme.palette.breadcrumbsBg }}>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={() => toggleDrawer(true)}
                            edge="start"
                            sx={{
                                marginRight: 5,
                                ...(isOpenState && { display: 'none' }),
                            }}
                        >
                            <MenuOutlined />
                        </IconButton>
                        <AccountBalanceWalletOutlined sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />
                        <Typography variant="h6" noWrap component="div">
                            WALLET
                        </Typography>
                        <Box sx={{ flexGrow: 1, bgcolor: "blue" }}>
                        </Box>
                        <Box sx={{ flexGrow: 0 }}>
                            <Grid container spacing={2}>
                                <Grid item>
                                    <Tooltip title="Notifications">
                                        <IconButton onClick={handleOpenNotif} sx={{ p: 0 }}>
                                            <StyledBadge badgeContent={pemberitahuans.length} color="error">
                                                <Avatar alt="Remy Sharp" sx={{ bgcolor: "rgba(92, 37, 141, 0.5)" }} >
                                                    <NotificationsOutlined />
                                                </Avatar>
                                            </StyledBadge>
                                        </IconButton>
                                    </Tooltip>
                                    <Menu
                                        sx={{ mt: '45px' }}
                                        id="menu-appbar"
                                        anchorEl={anchorElNotif}
                                        anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        open={Boolean(anchorElNotif)}
                                        onClose={handleCloseNotif}
                                        PaperProps={{
                                            elevation: 0,
                                            sx: {
                                                overflow: 'visible',
                                                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                                mt: 1.5,
                                                '& .MuiAvatar-root': {
                                                    width: 35,
                                                    height: 35,
                                                    ml: -0.5,
                                                    mr: 1,
                                                },
                                                '&:before': {
                                                    content: '""',
                                                    display: 'block',
                                                    position: 'absolute',
                                                    top: 0,
                                                    right: 14,
                                                    width: 10,
                                                    height: 10,
                                                    bgcolor: 'background.paper',
                                                    transform: 'translateY(-50%) rotate(45deg)',
                                                    zIndex: 0,
                                                }
                                            },
                                        }}
                                    >
                                        {
                                            pemberitahuans.length > 0 ?
                                                pemberitahuans.map((item, index) => (
                                                    <MenuItem key={index}>
                                                        {/* <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                                            <ListItem alignItems="flex-start"> */}
                                                                <ListItemIcon>
                                                                    <Assignment />
                                                                </ListItemIcon>
                                                                <ListItemText
                                                                    primary={item.judul + ' (' + item.jenis + ')'}
                                                                    secondary={
                                                                        <React.Fragment>
                                                                            <Typography
                                                                                sx={{ display: 'inline' }}
                                                                                component="span"
                                                                                variant="body2"
                                                                                color="text.primary"
                                                                            >
                                                                                {item.nm_opd}
                                                                            </Typography>
                                                                            {" — Rp. " + item.anggaran}
                                                                        </React.Fragment>
                                                                    }
                                                                />
                                                            {/* </ListItem>
                                                        </List> */}
                                                    </MenuItem>
                                                ))
                                                :
                                                <MenuItem onClick={handleCloseNotif} >
                                                    <ListItemText
                                                        primary="Tidak ada Pemberitahuan"
                                                        secondary={
                                                            <React.Fragment>
                                                                <Typography
                                                                    sx={{ display: 'inline' }}
                                                                    component="span"
                                                                    variant="body2"
                                                                    color="text.primary"
                                                                >

                                                                </Typography>
                                                            </React.Fragment>
                                                        }
                                                    />
                                                    {/* </ListItem> */}
                                                </MenuItem>
                                        }
                                    </Menu>
                                </Grid>
                                <Grid item>
                                    <Tooltip title="Open settings">
                                        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                            <Avatar alt="Remy Sharp" sx={{ bgcolor: "rgb(67, 137, 162)" }} src={profilPict} />
                                        </IconButton>
                                    </Tooltip>
                                    <Menu
                                        sx={{ mt: '45px' }}
                                        id="menu-appbar"
                                        anchorEl={anchorElUser}
                                        anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        open={Boolean(anchorElUser)}
                                        onClose={handleCloseUserMenu}
                                        PaperProps={{
                                            elevation: 0,
                                            sx: {
                                                overflow: 'visible',
                                                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                                mt: 1.5,
                                                '& .MuiAvatar-root': {
                                                    width: 32,
                                                    height: 32,
                                                    ml: -0.5,
                                                    mr: 1,
                                                },
                                                '&:before': {
                                                    content: '""',
                                                    display: 'block',
                                                    position: 'absolute',
                                                    top: 0,
                                                    right: 14,
                                                    width: 10,
                                                    height: 10,
                                                    bgcolor: 'background.paper',
                                                    transform: 'translateY(-50%) rotate(45deg)',
                                                    zIndex: 0,
                                                },
                                                width: '20ch',
                                            },
                                        }}
                                    >
                                        <MenuItem onClick={handleCloseUserMenu}>
                                            <Avatar /> Profile
                                        </MenuItem>
                                        <Divider />
                                        <MenuItem>
                                            Theme <FormControlLabel control={<SwitchTheme sx={{ m: 1 }} onChange={() => props.setMode(props.mode === "light" ? "dark" : "light")} checked={props.mode === 'dark' ? true : false} />} label={props.mode === 'dark' ? "Dark" : "Light"}
                                            />
                                        </MenuItem>
                                        <MenuItem onClick={props.onLogOut}>
                                            <ListItemIcon>
                                                <Logout fontSize="small" />
                                            </ListItemIcon>
                                            Logout
                                        </MenuItem>
                                    </Menu>
                                </Grid>
                            </Grid>
                        </Box>
                    </Toolbar>
                </AppBar>
                <Drawer variant="permanent" open={isOpenState}>
                    <DrawerHeader>
                        <IconButton onClick={() => toggleDrawer(false)}>
                            {theme.direction === 'rtl' ? <ChevronRight /> : <ChevronLeft />}
                        </IconButton>
                    </DrawerHeader>
                    <Divider />
                    <List>
                        <Tooltip title="Home" placement="right">
                            <ListItemButton to="/verif" component={Link} selected={"/verif" === location.pathname}>
                                <ListItemIcon>
                                    <Home />
                                </ListItemIcon>
                                <ListItemText primary="Home" />
                            </ListItemButton>
                        </Tooltip>
                        <Tooltip title="Validasi Dokumen" placement="right">
                            <ListItemButton
                                to="/verif/spm"
                                component={Link}
                                selected={
                                    "/verif/spm" === location.pathname ||
                                    "/verif/spm/periksa" === location.pathname ||
                                    "/verif/spm/periksa-acc" === location.pathname
                                }
                            >
                                <ListItemIcon>
                                    <Assignment />
                                </ListItemIcon>
                                <ListItemText primary="Validasi Dokumen" />
                            </ListItemButton>
                        </Tooltip>
                        {/* <Tooltip title="Acc" placement="right">
                            <ListItemButton to="/verif/acc" component={Link}
                                selected={
                                    "/verif/acc" === location.pathname ||
                                    "/verif/acc/periksa" === location.pathname
                                }>
                                <ListItemIcon>
                                    {<AssignmentTurnedIn />}
                                </ListItemIcon>
                                <ListItemText primary="Acc" />
                            </ListItemButton>
                        </Tooltip> */}
                        <Tooltip title="Proses SP2D" placement="right">
                            <ListItemButton to="/verif/proses_sp2d" component={Link}
                                selected={
                                    "/verif/proses_sp2d" === location.pathname ||
                                    "/verif/proses_sp2d/periksa" === location.pathname
                                }>
                                <ListItemIcon>
                                    {<Sync />}
                                </ListItemIcon>
                                <ListItemText primary="Proses SP2D" />
                            </ListItemButton>
                        </Tooltip>
                        {/* <Tooltip title="SP2D Ditandatangani" placement="right">
                            <ListItemButton to="/verif/sp2d_diserahkan" component={Link}
                                selected={
                                    "/verif/ttd_sp2d" === location.pathname
                                }>
                                <ListItemIcon>
                                    {<Sync />}
                                </ListItemIcon>
                                <ListItemText primary="SP2D Ditandatangani" />
                            </ListItemButton>
                        </Tooltip>
                        <Tooltip title="SP2D Diserahkan" placement="right">
                            <ListItemButton to="/verif/sp2d_diserahkan" component={Link}
                                selected={
                                    "/verif/sp2d_diserahkan" === location.pathname
                                }>
                                <ListItemIcon>
                                    {<Sync />}
                                </ListItemIcon>
                                <ListItemText primary="SP2D Diserahkan" />
                            </ListItemButton>
                        </Tooltip> */}
                        <Tooltip title="Selesai" placement="right">
                            <ListItemButton to="/verif/selesai" component={Link} selected={"/verif/selesai" === location.pathname}>
                                <ListItemIcon>
                                    {<DoneAllOutlined />}
                                </ListItemIcon>
                                <ListItemText primary="Selesai" />
                            </ListItemButton>
                        </Tooltip>
                        <Divider />
                        <Tooltip title="Kontrak" placement="right">
                            <ListItemButton to="/verif/kontrak" component={Link}
                                selected={
                                    "/verif/kontrak" === location.pathname ||
                                    "/verif/kontrak/detail" === location.pathname ||
                                    "/verif/kontrak/adendum-detail" === location.pathname
                                }
                            >
                                <ListItemIcon>
                                    {<AssignmentIndOutlined />}
                                </ListItemIcon>
                                <ListItemText primary="Kontrak" />
                            </ListItemButton>
                        </Tooltip>
                    </List>
                    <Divider />
                    <List
                        aria-labelledby="utility"
                        subheader={
                            <ListSubheader component="div" id="utility">
                                Utility
                            </ListSubheader>
                        }
                    >
                        <Tooltip title="Kelengkapan" placement="right">
                            <ListItemButton to="/verif/kelengkapan" selected={"/verif/kelengkapan" === location.pathname} component={Link}>
                                <ListItemIcon>
                                    <Article />
                                </ListItemIcon>
                                <ListItemText primary="Kelengkapan" />
                            </ListItemButton>
                        </Tooltip>
                    </List>
                    {/* <List>
                        {['All mail', 'Trash', 'Spam'].map((text, index) => (
                            <ListItem key={text} disablePadding>
                                <ListItemButton>
                                    <ListItemIcon>
                                        {index % 2 === 0 ? <Inbox /> : <Mail />}
                                    </ListItemIcon>
                                    <ListItemText primary={text} />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List> */}
                </Drawer>
                <Box component="main" sx={{ flexGrow: 1 }}>
                    <DrawerHeader />

                    {props.child}
                </Box>
            </Box>
        </>
    )
}

export default NavVr